import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../cn.js";
const STATUS = {
    not_started: "bg-tint text-ink-2",
    in_progress: "bg-[#fbefd9] text-[#8a570b]",
    done: "bg-green-soft text-green-ink",
    to_evaluate: "bg-[#ecebf7] text-violet",
};
export function StatusChip({ status, label, className }) {
    return _jsx("span", { className: cn("inline-flex items-center shrink-0 rounded-md px-2 py-1 text-xs font-semibold tracking-wide", STATUS[status], className), children: label });
}
const PRIORITY = { normal: "bg-tint text-ink-2", urgent: "bg-[#fbefd9] text-[#8a570b]", blocking: "bg-[#fbe3e3] text-danger" };
export function PriorityChip({ priority, label, className }) {
    return (_jsxs("span", { className: cn("inline-flex items-center gap-1 shrink-0 rounded-md px-2 py-1 text-xs font-semibold", PRIORITY[priority], className), children: [priority === "blocking" && _jsx("span", { "aria-hidden": true, className: "h-1.5 w-1.5 rounded-full bg-current" }), label] }));
}
const NEED = {
    reported: "bg-tint text-ink-2",
    validated_by_chef: "bg-[#ecebf7] text-violet",
    sent_to_purchasing: "bg-[#e6ecfb] text-navy",
    in_stock: "bg-green-soft text-green-ink",
    ordered: "bg-[#fbefd9] text-[#8a570b]",
    delivered_to_site: "bg-green-soft text-green-ink",
    closed: "bg-tint text-ink-3",
    rejected: "bg-[#fbe3e3] text-danger",
    deferred: "bg-tint text-ink-2",
};
export function NeedStateChip({ state, label, className }) {
    return _jsx("span", { className: cn("inline-flex items-center shrink-0 rounded-md px-2 py-1 text-xs font-semibold", NEED[state], className), children: label });
}
//# sourceMappingURL=Chips.js.map